import AMapLoader from '@amap/amap-jsapi-loader';

let mapInstance = null;
let AMap = null;
let drivingService = null;

// 安全配置 
const securityConfig = {
    securityJsCode: 'c6bcd7dc52ae28e9567c690ba7939b72'
    //securityJsCode: 'f0b049f79cf8b04b93e5db2879fa06c6'
};

export async function initMap(containerId) {
    try {
        // 加载安全配置
        window._AMapSecurityConfig = {
            securityJsCode: securityConfig.securityJsCode
        };

        AMap = await AMapLoader.load({
            key: '24f21e97ad61f5d65b50a38c175b3fe4',
            //key: '1d859992798344b701aad0bc875f11c6',
            version: '2.0',
            plugins: [
                'AMap.Geolocation',
                'AMap.Marker',
                'AMap.Polyline',
                'AMap.Driving',
                'AMap.AutoComplete',
                'AMap.PlaceSearch'
            ]
        });

        mapInstance = new AMap.Map(containerId, {
            zoom: 13,
            center: [116.397428, 39.90923],
            viewMode: '2D'
        });

        // 初始化驾车路线服务
        drivingService = new AMap.Driving({
            map: mapInstance,
            policy: AMap.DrivingPolicy.REAL_TRAFFIC,
            hideMarkers: true,
            showTraffic: true // 显示实时交通
        });

        return { map: mapInstance, AMap, drivingService };
    } catch (error) {
        console.error('地图加载失败:', error);
        throw error;
    }
}

export function addMarker(map, position, options = {}) {
    const marker = new AMap.Marker({
        position,
        map,
        ...options
    });
    return marker;
}

export function updateMarker(marker, newPosition) {
    marker.setPosition(newPosition);
}

export function searchRoute(drivingService, start, end, callback) {
    drivingService.search(start, end, (status, result) => {
        if (status === 'complete') {
            callback(null, result);
        } else {
            callback(new Error('路线规划失败: ' + status), null);
        }
    });
}

export function createVehicleMarker(AMap, position, options = {}) {
    const defaultOptions = {
        plateNumber: '未知车牌',
        direction: 0,
        iconUrl: '../../img/bus-icon.png',
        highlight: false
    };

    const { plateNumber, direction, iconUrl, highlight } = { ...defaultOptions, ...options };

    const markerContent = document.createElement('div');
    markerContent.className = `vehicle-marker-container ${highlight ? 'highlight' : ''}`;

    // 创建图标
    const icon = document.createElement('div');
    icon.className = 'vehicle-icon';
    icon.style.transform = `rotate(${direction}deg)`;
    icon.style.backgroundImage = `url(${iconUrl})`;

    // 创建车牌标签
    const plate = document.createElement('div');
    plate.className = 'plate-number';
    plate.textContent = plateNumber;

    markerContent.appendChild(icon);
    markerContent.appendChild(plate);

    return new AMap.Marker({
        position,
        content: markerContent,
        offset: new AMap.Pixel(-20, -20),
        zIndex: highlight ? 101 : 100
    });
}

export function updateVehicleMarker(marker, options = {}) {
    const content = marker.getContent();
    if (!content || !content.querySelector) return;

    // 更新方向
    if (typeof options.direction !== 'undefined') {
        const icon = content.querySelector('.vehicle-icon');
        if (icon) {
            icon.style.transform = `rotate(${options.direction}deg)`;
        }
    }

    // 更新车牌号
    if (options.plateNumber) {
        const plate = content.querySelector('.plate-number');
        if (plate) {
            plate.textContent = options.plateNumber;
        }
    }

    // 更新高亮状态
    if (typeof options.highlight !== 'undefined') {
        content.classList.toggle('highlight', options.highlight);
        marker.setzIndex(options.highlight ? 101 : 100);
    }
}